<template>
  <div>
    <!-- Etapa D: importa contas do Active Directory (busca por nome/login ou por grupo).
         O navegador envia só os logins; nome e e-mail são lidos do AD pelo servidor. -->
    <div class="modal fade" id="importarAD" tabindex="-1">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header text-center">
            <h4 class="modal-title w-300 font-weight-bold">Importar usuários do AD</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 col-md-4 col-lg-4">
                <label for="modoAD">Buscar por</label>
                <select id="modoAD" class="browser-default custom-select" v-model="modo">
                  <option value="busca">Nome ou login</option>
                  <option value="grupo">Grupo do AD</option>
                </select>
              </div>
              <div class="col-sm-12 col-md-8 col-lg-8">
                <label for="termoImportarAD">{{ modo == 'grupo' ? 'Nome do grupo' : 'Nome ou login (mín. 3 caracteres)' }}</label>
                <div class="input-group">
                  <input id="termoImportarAD" type="text" class="form-control" v-model="termo" maxlength="128" v-on:keyup.enter="consultar" />
                  <div class="input-group-append">
                    <button class="btn btn-sm btn-outline-primary m-0" type="button" :disabled="carregando" @click="consultar">
                      <i class="fa fa-search"></i>&nbsp;Buscar
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-3" v-if="carregando"><Loading /></div>

            <div class="table-responsive mt-2 tabela-ad" v-if="lista.length && !carregando">
              <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th style="width:40px">
                      <!-- o tema (MDB) esconde o checkbox nativo: usar custom-control + label -->
                      <div class="custom-control custom-checkbox" title="Marcar todos">
                        <input type="checkbox" class="custom-control-input" id="importarAD-todos"
                               :checked="todosMarcados" :disabled="!disponiveis.length"
                               @change="marcarTodos($event.target.checked)" />
                        <label class="custom-control-label" for="importarAD-todos"></label>
                      </div>
                    </th>
                    <th>Login</th>
                    <th>Nome</th>
                    <th>E-mail</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(u, i) in lista" :key="u.strusuario"
                      :class="{ 'text-muted': !podeImportar(u), 'linha-ad': podeImportar(u), 'table-primary': marcados.includes(u.strusuario) }"
                      @click="alternar(u)">
                    <td @click.stop>
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" :id="'importarAD-' + i"
                               v-model="marcados" :value="u.strusuario" :disabled="!podeImportar(u)" />
                        <label class="custom-control-label" :for="'importarAD-' + i"></label>
                      </div>
                    </td>
                    <td><strong>{{u.strusuario}}</strong></td>
                    <td>{{u.strnome}}</td>
                    <td>
                      <span v-if="u.cadastrado" class="badge badge-secondary">já cadastrado</span>
                      <span v-else-if="!u.stremail" class="badge badge-warning">sem e-mail no AD</span>
                      <span v-else>{{u.stremail}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p class="mt-2 mb-0" v-if="lista.length && !carregando">
              <small>{{lista.length}} conta(s) ativa(s) encontrada(s), {{marcados.length}} selecionada(s).
              Contas sem e-mail no AD não podem ser importadas aqui (o comprovante de votação vai por e-mail): cadastre-as em "Novo Usuário".</small>
            </p>

            <div class="row mt-3">
              <div class="col-sm-12 col-md-6 col-lg-6">
                <label for="perfilImportarAD">Perfil dos importados</label>
                <select id="perfilImportarAD" class="browser-default custom-select" v-model="intidperfil">
                  <option :value="perfil.eleitor">Eleitor</option>
                  <option :value="perfil.comissao">Comissão</option>
                  <option :value="perfil.administrador">Administrador</option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button class="btn btn-primary" :disabled="!marcados.length || importando" @click="importar">
              <i class="fa fa-download mr-1 pr-1"></i> Importar selecionados
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from './../misc/Loading'

export default {
  components: { Loading },
  data() {
    return {
      modo: 'busca',
      termo: '',
      lista: [],
      marcados: [],
      intidperfil: process.env.VUE_APP_PERMISSAO_ELEITOR,
      carregando: false,
      importando: false
    };
  },
  computed: {
    perfil() {
      return {
        administrador: process.env.VUE_APP_PERMISSAO_ADMINISTRADOR,
        comissao: process.env.VUE_APP_PERMISSAO_COMISSAO,
        eleitor: process.env.VUE_APP_PERMISSAO_ELEITOR
      };
    },
    disponiveis() {
      return this.lista.filter(u => this.podeImportar(u)).map(u => u.strusuario);
    },
    todosMarcados() {
      return this.disponiveis.length > 0 && this.marcados.length === this.disponiveis.length;
    }
  },
  methods: {
    erro(e, padrao) {
      toastr.error((e && e.response && e.response.data && e.response.data.mensagem) || padrao);
    },
    podeImportar(u) {
      return !u.cadastrado && !!u.stremail;
    },
    /** Clique na linha marca/desmarca (só contas que podem ser importadas). */
    alternar(u) {
      if (!this.podeImportar(u)) return;
      const i = this.marcados.indexOf(u.strusuario);
      if (i >= 0) this.marcados.splice(i, 1); else this.marcados.push(u.strusuario);
    },
    marcarTodos(marcar) {
      this.marcados = marcar ? this.disponiveis.slice() : [];
    },
    async consultar() {
      const termo = (this.termo || '').trim();
      if (this.modo == 'busca' && termo.length < 3) return toastr.error("Digite ao menos 3 caracteres");
      if (this.modo == 'grupo' && !termo) return toastr.error("Informe o nome do grupo");
      this.carregando = true;
      this.lista = [];
      this.marcados = [];
      const req = this.modo == 'grupo'
        ? axios.get("/usuarios/ad/grupo", { params: { nome: termo } })
        : axios.get("/usuarios/ad/buscar", { params: { termo } });
      await req.then(res => {
        this.lista = res.data.usuarios || [];
        if (!this.lista.length) toastr.info("Nenhuma conta ativa encontrada no AD");
      }, e => this.erro(e, "Falha ao consultar o AD"));
      this.carregando = false;
    },
    async importar() {
      this.importando = true;
      await axios.post("/usuarios/ad/importar", { logins: this.marcados, intidperfil: this.intidperfil })
        .then(res => {
          const d = res.data || {};
          const linha = (rotulo, l) => (l && l.length) ? `<li>${rotulo}: ${l.length}</li>` : '';
          swal.fire({
            title: "Importação concluída",
            type: "success",
            html: `<ul style="text-align:left">${linha('Importados', d.importados)}${linha('Já cadastrados', d.ja_cadastrados)}` +
                  `${linha('Não encontrados ou desativados no AD', d.nao_encontrados)}${linha('Sem e-mail no AD', d.sem_email)}</ul>`
          });
          this.$emit('refreshComponent');
          $(".modal").modal("hide");
        }, e => this.erro(e, "Falha ao importar do AD"));
      this.importando = false;
    }
  }
};
</script>

<style>
.tabela-ad {
  max-height: 320px;
  overflow-y: auto;
  font-size: 10pt;
}
.tabela-ad .linha-ad {
  cursor: pointer;
}
.tabela-ad td .custom-control {
  min-height: 1.2rem;
}
</style>
